import React, { useState } from "react";
import { Grid, Divider } from "@mui/material";
import { InputButton, InputDropDown, InputText } from "components/UI";
import { useGetPrintAs, useRePrint } from "shared/services/master/barcodeprint";
import { responseErrors } from "utils";
import InputCurrency from "components/UI/InputCurrency";
import { useConfirmDialogContext } from "context/confirmDialogContext";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { waitAndPrintBarcode } from "shared/services/common-dowload/download-helper-service";
import { useSelector } from "react-redux";
import { COMMON_ENUM } from "shared/constants";

const RePrintMode = ({ mode, setMsgAlert, setMsgError, functionId }) => {
  const [form, setForm] = React.useState({
    mode: mode,
    printAs: "",
    barcodeId: "",
    numberOfCopy: 1,
  });
  const userInfo = useSelector(state => state.auth.user);
  const [disabledPrintBarcodeBtn, setDisabledPrintBarcodeBtn] = useState(false);
  // api
  const { data: printAsData } = useGetPrintAs({
    dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
  });
  const confirmDialogCtx = useConfirmDialogContext();
  const createDataAsync = useRePrint();
  const { startLoading, stopLoading } = useLoadingContext();

  // handle print
  const handlePrint = async () => {
    try {
      setMsgAlert([]);
      setMsgError([]);
      const saveConfirm = await confirmDialogCtx.success({
        type: "confirmPrint",
      });
      if (!saveConfirm) {
        return;
      }
      // const item = printAsData?.find(val => val.plantCd === form.printAs);

      const body = {
        dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
        printType: form?.mode,
        printAs: form.printAs,
        // numOfCopy: form.numberOfCopy,
        numOfCopy: form.numberOfCopy.toString(),
        barcodeId: form.barcodeId,
        printLocation: userInfo.companyAbbr,
        user: {
          userInfo: {
            userId: userInfo.userName,
            email: userInfo.mail,
          },
        },
      };
      startLoading();
      const response = await createDataAsync(body);
      waitAndPrintBarcode(60, response, setMsgError, stopLoading);
      // stopLoading();
      return;
    } catch (error) {
      stopLoading();
      console.log(error);
      const errors = responseErrors(error);
      setMsgError(errors);
      return;
    }
  };
  const handleClear = () => {
    setMsgAlert([]);
    setMsgError([]);
    setForm({
      mode: mode,
      printAs: "",
      barcodeId: "",
      numberOfCopy: 1,
    });
    setDisabledPrintBarcodeBtn(false);
    setTimeout(() => {
      document.getElementById("select_printAs").focus();
    }, 600);
  };
  return (
    <>
      <Grid item xs={1} />
      <Grid item xs={5} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 0px", width: "325px" }}>*Print As : </strong>
        <InputDropDown
          id="select_printAs"
          value={form.printAs}
          onChange={e =>
            setForm(old => ({
              ...old,
              printAs: e.target.value,
            }))
          }
          memu={printAsData?.map(val => ({
            key: val.plantCd,
            value: val.impExpCd,
          }))}
          placeholder="<Select>"
          defaultValue=""
          required
          tabIndex={1}
          focus={true}
        />
      </Grid>
      <Grid item xs={1} />

      <Grid item xs={5} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 0px", width: "325px" }}>*R-Module Barcode ID : </strong>
        <InputText
          fullWidth
          id="input_barcodeId"
          value={form.barcodeId}
          onChange={e =>
            setForm(old => ({
              ...old,
              barcodeId: e.target.value.match(/^[a-zA-Z0-9]*$/) ? e.target.value?.toUpperCase() : old.barcodeId,
            }))
          }
          required
          maxLength={14}
          tabIndex={1}
        />
      </Grid>
      <Grid item xs={1} />

      <Grid item xs={5} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 0px", width: "325px" }}>*Number of Copy : </strong>
        <InputCurrency
          fullWidth
          id="input_numOfCopy"
          value={form?.numberOfCopy}
          onChange={e =>
            setForm(old => ({
              ...old,
              numberOfCopy: e.value,
            }))
          }
          maxLimit={10}
          required
          tabIndex={1}
        />
      </Grid>
      <Grid item xs={12} display="flex" justifyContent="flex-end" marginTop="24px">
        <InputButton
          value="Print Barcode"
          onClick={handlePrint}
          disabled={disabledPrintBarcodeBtn}
          name={`${functionId}PrintBarcode`}
          tabIndex={1}
        />
        <InputButton
          value="Clear"
          onClick={handleClear}
          onKeyDown={e => {
            if (e.key === "Tab") {
              e.preventDefault();
              document.getElementById("select_printAs").focus();
            }
          }}
          name={`${functionId}Clear`}
          tabIndex={1}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ my: 2 }} />
      </Grid>
    </>
  );
};

export default RePrintMode;
